import type {
  TripTypesSideBar,
  TripTypesSideBarCategory,
} from '@layers/web/services/types/navigation-api.ts'

const findSidebarCategory = (
  sidebar: TripTypesSideBar,
  categoryId: string
): TripTypesSideBarCategory | null => {
  const category = sidebar.sections
    .flatMap(({ categories }) => categories)
    .find(({ id }) => String(id) === String(categoryId))

  if (!category) {
    return null
  }

  return category
}

const isNumericSidebarCategoryId = (categoryId: string): boolean => {
  return /^\d+$/.test(String(categoryId))
}

export {
  findSidebarCategory,
  isNumericSidebarCategoryId,
}
